var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CommonEmployeeDetailsModal',{attrs:{"title":"Manage Away Type"}},[_c('CompanyAwayDetailEditForm',{attrs:{"is-busy":_vm.isBusy,"form-set":_vm.selectedAway},on:{"handle-submit":_vm.handleSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }